import axios, { AxiosResponse } from "axios";
import { ResponseAuth } from "./_models";
import { createApiHeaders } from "../utils/api-headers";

const API_URL = process.env.REACT_APP_DISBURSEMENT_API_URL;

export const LOGIN_URL = `${API_URL}/user/login`;

export function login(payload: { userName: string; tokenLogin: string }) {
  return axios
    .post(LOGIN_URL, payload, {
      headers: {
        ...createApiHeaders(),
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<ResponseAuth>) => {
      return response.data;
    });
}
